import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFormTypeItem {
  id: number;
  code: string;
  name: string;
}

export interface IFormTypeItem extends TFormTypeItem {}

const FormTypeItem = Model(
  (model: TFormTypeItem): IFormTypeItem => {
    const _formTypeItem: TFormTypeItem = Object.assign({}, model);

    let create = (FormTypeItem: IFormTypeItem): IFormTypeItem => {
      let obj = ValidatableObject(FormTypeItem);
      return obj;
    };

    let FormTypeItem = {
      get id() {
        return _formTypeItem.id;
      },
      set id(value) {
        _formTypeItem.id = value;
      },
      get code() {
        return _formTypeItem.code;
      },
      set code(value) {
        _formTypeItem.code = value;
      },
      get name() {
        return _formTypeItem.name;
      },
      set name(value) {
        _formTypeItem.name = value;
      }
    };

    return create(FormTypeItem);
  }
);

export default FormTypeItem;
